module.exports = __webpack_public_path__ + "img/img_logo.911569c3.png";